const HEARTBEAT_URL = 'http://127.0.0.1:47821/heartbeat';
export const PROBE_INTERVAL = 5000;
export const JOIN_EARLY_MS = 15 * 60 * 1000;

export function detectPlatform() {
  const ua = (navigator.userAgent || '').toLowerCase();
  if (ua.includes('win')) return 'windows';
  if (ua.includes('mac')) return 'mac';
  if (ua.includes('linux') || ua.includes('x11')) return 'linux';
  return 'windows';
}

export async function probeAgent() {
  try {
    const res = await fetch(HEARTBEAT_URL, { cache: 'no-store' });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

export function canJoinScheduledInterview(schedule) {
  if (!schedule) return { ok: false };
  if (schedule.status === 'ACTIVE') return { ok: true };
  if (!schedule.scheduledAt) return { ok: true };
  const opens = new Date(schedule.scheduledAt).getTime() - JOIN_EARLY_MS;
  if (Date.now() < opens) {
    return {
      ok: false,
      message: `Opens 15 minutes before ${new Date(schedule.scheduledAt).toLocaleString()}`,
    };
  }
  return { ok: true };
}
